<template>
    <collapsible-card :title="'Companies Served for the Last 30 Days'" v-show="showChart" ref="cCard">
        <div class="cardContent centerChart chartContent">
            <div class="chart">
                <div id="companyChart" v-show="showChart"></div>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import Highcharts from 'highcharts'
import CollapsibleCard from '../CollapsibleCard.vue'

export default {
    name: "berth-chart-companies",
    components: {
        CollapsibleCard
    },
    data: () => ({
        showChart: false,
    }),
    methods: {
        createChart: function(vesselsVisited) {
            var globv = this;
            globv.showChart = false;
            if (vesselsVisited && vesselsVisited.length > 0) {
                let data = [];

                // Not super happy with what's below but it seemed to be the best solution I could come up with.
                // Maybe revesit this with fresh eyes and a chain of maps?
                for (let vessel of vesselsVisited) {
                    let elem = data.find(e => e.name === globv.formatCompanyName(vessel['company']));
                    if (elem != undefined) {
                        elem['y'] += 1;
                    } else {
                        data.push({
                            name: globv.formatCompanyName(vessel['company']),
                            y: 1
                        });
                    }
                }

                Highcharts.theme = {
                    colors: [
                        "#ED4553",
                        "#2B76DE",
                        "#6DDF76",
                        "#FC7C73",
                        "#409BC9",
                        "#F8B18B",
                        "#86E1E4",
                        "#F7D8BB",
                        "#CDEAE5",
                        "#F1FAEE"
                    ]
                }

                Highcharts.setOptions(Highcharts.theme);

                Highcharts.chart('companyChart', {
                    chart: {
                        type: 'pie',
                        backgroundColor: '#22293d'
                    },
                    credits: {
                        enabled: false,
                        credits: false
                    },
                    title: {
                        text: null
                    },
                    tooltip: {
                        pointFormat:
                            'Usage: {point.percentage:.2f} %'
                    },
                    accessibility: {
                        point: {
                            valueSuffix: '%'
                        }
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: false,
                            },
                            showInLegend: true
                        }
                    },
                    legend: {
                        itemStyle: {
                            color: "#fff"
                        },
                        labelFormatter: function() {
                            return this.name + ": " + this.y + (this.y == 1 ? " vessel" : " vessels");
                        }
                    },
                    series: [{
                        name: 'Companies',
                        data: data
                    }]
                });

                globv.showChart = true;
                globv.$refs.cCard.adjustHeight();
            }
        },
        reset: function() {
            var globv = this;
            globv.showChart = false;
        },
        // Prefer ES6 split and concat rather than regex for performance reasons
        formatCompanyName: function(companyName) {
            return companyName.replace("_", " ").toLowerCase()
                .split(' ')
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');
        }
    }
}

</script>